import React from 'react';
import AlgorithmsDetails from '../AlgorithmsDetails/AlgorithmsDetails';
import styles from './App.module.css';
import {MAIN_URL} from '../../constants'
class App extends React.Component {

    state = {
        data: [],
        category: [],
        visibility: false,
        checkedCatIndex: null,
        allBooksVisibility: false,
        allBooks: []
    };

    createMarkup = text => {
        return {__html: text}
    };

    componentDidMount = async () => {
        const requestData = await fetch(`${MAIN_URL}/wp-json/wp/v2/categories?per_page=100&parent=8`, {method: 'GET'});
        const responseData = await requestData.json();
        const categoriesList = responseData.map(category => {
            return {...category};
        })
        this.setState({data: categoriesList})
        this.showAllBooksHandler()
    }

    showAllBooksHandler = async () => {
        let books = [];
        this.state.data.map(async (item) => {
                const url = `${MAIN_URL}/wp-json/wp/v2/posts?categories=${item.id}&per_page=100&parent=8`;
                const requestData = await fetch(url, {method: 'GET'});
                const responseData = await requestData.json();
                responseData.map(book => {
                    books.push({...book});
                })
            }
        );
        await this.setState({allBooks: books})
    };

    changeCategory = (data, index) => {
        this.setState({visibility: false, checkedCatIndex: index});
        setTimeout(() => this.setState({category: data, visibility: true}), 1)
    };

    render() {
        console.log('this.state', this.state)
        let cat = this.state.category;
        let allBooks = this.state.allBooks
        return (
            <div className={styles.wrap}>
                {
                    this.state.data.map((category, index) =>
                        <div
                            className={this.state.checkedCatIndex === index ? styles.category : styles.unpressedCategory}
                            key={index}
                            onClick={() => {
                                this.changeCategory(this.state.data[index], index)
                            }}
                            dangerouslySetInnerHTML={this.createMarkup(`<a  target="_blank">${category.name}</a>`)}
                        />
                    )
                }
                    <div
                        className={this.state.allBooksVisibility ? styles.category : styles.unpressedCategory}
                        onClick={() => {
                            this.setState({allBooksVisibility: !this.state.allBooksVisibility})
                        }}
                        dangerouslySetInnerHTML=
                            {this.createMarkup(`<a  target="_blank">${this.state.allBooksVisibility ?'Скрыть все книги':'Показать все книги'}</a>`)}
                    />
                    {this.state.visibility &&
                    <div style={{margin: 10, maxWidth: '90%'}}>
                        <AlgorithmsDetails
                            category={cat}/>
                    </div>
                    }
                    {this.state.allBooksVisibility &&
                    <div style={{margin: 10, maxWidth: '90%'}}>
                        <AlgorithmsDetails
                            allBooks={allBooks}/>
                    </div>
                    }
                </div>
                )
                }

                }

                export default App;
